// export default (path, withOrigin = false) =>
//   `${withOrigin ? window.location.origin : ''}${process.env.PUBLIC_URL}${path}`;

const path = (path, withOrigin = false) => `${withOrigin ? window.location.origin : ''}${process.env.PUBLIC_URL}${path}`;
export default path;
